
    const pyconfig = {
    apiBaseUrl: "https://avatar-model.neurosyncai.ai"
  };
 
  export default pyconfig;
